import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, full = false }) {
  const { user, isFull } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0D14]">
        <Loader2 className="w-8 h-8 animate-spin text-[#3B82F6]" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (full && !isFull) {
    return <Navigate to="/" replace />;
  }

  return children;
}
